<template>
    <div class="modal fade" id="editModelItemsModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" style="min-width: 90%; height: 90vh;" role="document">
            <div class="modal-content" style="min-width: 90%; height: 90vh;">
                <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                    <i class="fad fa-times-circle"></i>
                </div>

                <section class="project-step" v-if="model">
                    <div class="modal-header">
                        <h5 class="modal-title">Modifica disponibilitate - {{model.rooms_count ? model.rooms_count.name : ''}}
                            tip {{model.model_type}}</h5>
                    </div>
                    <div class="container-fluid modal-body custom-edit-modal-content" id="edit_modal_content">
                        <div class="custom-container">
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div class="left-content">
                                        <button type="button" class="general-btn positive-btn"
                                                @click="openAddBuildingModal(project.id)">
                                            <i class="fad fa-plus-circle"></i>
                                            <span> Adauga bloc </span>
                                        </button>
                                    </div>
                                    <p class="custom-input-error" id="general_error"></p>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div class="blocks-tabs" role="tablist">
                                        <p :id="'block' + building.id" v-for="(building, index) in buildings"
                                           :key="`block-${index}`" style="position: relative;">
                                            <a :id="'building' + building.id" data-toggle="tab"
                                               :href="'#building' + building.id" role="tab"
                                               :aria-controls="'building' + building.id" aria-selected="true"
                                               :class="{active:building.isActive, show:building.isActive}"
                                               @click.stop.prevent="setActive(building)">
                                                <i class="fad fa-building"></i>
                                                <span class="text-checkbox-building"> Bloc {{building.title}} </span>
                                                <span class="text-checkbox-counter" data-toggle="tooltip" data-placement="top" title="Numar apartamente">{{ buildingOffers(building) }}</span>
                                            </a>
                                        </p>
                                    </div>
                                    <div class="blocks-tabs-content tab-content">
                                        <div v-for="(building, indexBuilding) in buildings"
                                             :key="`building-${indexBuilding}`"
                                             class="tab-pane fade"
                                             :class="{active:building.isActive, show:building.isActive}"
                                             :id="'building' + building.id"
                                             role="tabpanel"
                                             :aria-labelledby="'building' + building.id + '-tab'"
                                        >
                                            <h5>
                                                {{ model.rooms_count ? model.rooms_count.name : ''}}
                                                tip {{ model.model_type }} - Total oferte: {{ buildingOffers(building) }}
                                            </h5>
                                            <div class="levels-container">
                                                <div class="single-level-wrapper"
                                                     v-for="(level, indexLevel) in building.levels"
                                                     :key="`level-${indexLevel}`">
                                                    <h3>  {{level.title}} ({{ level.itemRows.length }} oferte) </h3>
                                                    <div class="add-field-btn"
                                                         @click="addItemRow(level.itemRows)">
                                                        <i class="fad fa-plus-circle"></i> Adauga
                                                    </div>
                                                    <div class="single-level-row"
                                                         :class="{highlighted:itemRow.highlighted}"
                                                         v-for="(itemRow, indexItem) in level.itemRows"
                                                         :key="`row-${indexItem}`">
                                                        <div class="row">
                                                            <div class="col-xl-1 col-lg-2 col-md-6 col-sm-6 col-6">
                                                                <div class="level-item-nr level-strip-cell">
                                                                    <p class="level-cell-heading" v-if="model.type === 'commercial'"> Nr. Spaţiu </p>
                                                                    <p class="level-cell-heading" v-else> Nr. Ap </p>
                                                                    <div class="input-container">
                                                                        <div class="input-group">
                                                                            <input type="text" v-model="itemRow.apartmentNumber">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6">
                                                                <div class="level-strip-cell">
                                                                    <p class="level-cell-heading"> Model </p>
                                                                    <p class=""> {{model.rooms_count ?
                                                                        model.rooms_count.name : ''}}
                                                                        tip {{model.model_type}} </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-3 col-lg-8 col-md-12 col-sm-12 col-12">
                                                                <p class="level-cell-heading"> Suprafata(m²) </p>
                                                                <div class="custom-surface-col">
                                                                    <div class="level-item-size level-strip-cell">
                                                                        <div class="input-container">
                                                                            <div class="input-group mg-b">
                                                                                <input type="number" v-model="itemRow.usefulSurface">
                                                                                <span> Totala </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="level-item-size level-strip-cell">
                                                                        <div class="input-container">
                                                                            <div class="input-group mg-b">
                                                                                <input type="number" v-model="itemRow.terraceSurface">
                                                                                <span> Balcon </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 ml-auto">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> * Pret </p>
                                                                    <div class="input-container">
                                                                        <div class="input-group mg-b">
                                                                            <input type="number" v-model="itemRow.price">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 ml-auto">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Pret cu credit </p>
                                                                    <div class="input-container">
                                                                        <div class="input-group mg-b">
                                                                            <input type="number" v-model="itemRow.credit_price">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> * Status </p>
                                                                    <div class="input-container">
                                                                        <div class="input-group mg-b">
                                                                            <select name="rooms" v-model="itemRow.status">
                                                                                <option value="available"> Disponibil</option>
                                                                                <option value="reserved"> Rezervat</option>
                                                                                <option value="sold"> Vandut</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="single-level-row-availability">
                                                            <!-- <div class="general-check step-check">
                                                                <input type="checkbox"
                                                                       v-model="itemRow.showStatusForClients"
                                                                       :id="`clients_availability-bld${building.id}-${indexLevel}-${indexItem}`"
                                                                       class="custom-checkbox">
                                                                <label :for="`clients_availability-bld${building.id}-${indexLevel}-${indexItem}`"
                                                                       class="custom-checkbox-label">
                                                                    <span></span>
                                                                    <p>
                                                                        Vizibil pentru clienti
                                                                    </p>
                                                                </label>
                                                            </div> -->
<!--                                                            <div class="general-check step-check">-->
<!--                                                                <input type="checkbox"-->
<!--                                                                       v-model="itemRow.showStatusForAgencies"-->
<!--                                                                       :id="`agents_availability-bld${building.id}-${indexLevel}-${indexItem}`"-->
<!--                                                                       class="custom-checkbox">-->
<!--                                                                <label :for="`agents_availability-bld${building.id}-${indexLevel}-${indexItem}`"-->
<!--                                                                       class="custom-checkbox-label">-->
<!--                                                                    <span></span>-->
<!--                                                                    <p>-->
<!--                                                                        Vizibil pentru agenti-->
<!--                                                                    </p>-->
<!--                                                                </label>-->
<!--                                                            </div>-->
                                                        </div>
                                                        <div class="remove-field-btn">
                                                            <i class="fad fa-minus-circle"
                                                               v-on:click="removeItemRow(indexItem, level.itemRows)"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h5>
                                                {{ model.rooms_count ? model.rooms_count.name : ''}}
                                                tip {{ model.model_type }} - Total oferte: {{ buildingOffers(building) }}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer custom-edit-modal-footer">
                        <div class="center-content mt-3 save-btn">
                            <button type="button" class="general-btn positive-btn" @click="save()">
                                <i class="fad fa-save"></i>
                                <span> Salveaza </span>
                            </button>
                        </div>
                    </div>
                    <add-block-modal></add-block-modal>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import AddBlockModal from '../../partials/AddBlockModal'

export default {
    name: "DeveloperEditModelItems",
    components: {
        AddBlockModal: AddBlockModal
    },
    data() {
        return {
            model: null,
            project: null,
            buildingsDefault: null,
            buildings: [],
            activeTab: {},
            toEditItemId: 0
        }
    },
    async mounted() {
        let vm = this
        $('#editModelItemsModal').on('hidden.bs.modal', function () {
            vm.model = null
            vm.project = null
            vm.buildingsDefault = null
            vm.buildings = []
            vm.activeTab = {}
            vm.toEditItemId = 0
        });
        this.$eventBus.$on('OPEN_EDIT_MODEL_ITEMS_MODAL',async function (payLoad) {
            vm.triggerLoader(true)
            await vm.getModelData(payLoad.modelId,payLoad.itemId)
            vm.triggerLoader(false)
            $('#editModelItemsModal').modal('show')
        });
    },
    methods: {
        async getModelData(modelId, itemId=null) {
            let vm = this
            vm.triggerLoader(true)
            this.toEditItemId = itemId
            await window.axios.get(`/developer/model-data-edit/${modelId}`)
                .then(function (resp) {
                    vm.triggerLoader(false)
                    vm.model = resp.data.data.model
                    vm.project = resp.data.data.model.project
                    vm.buildingsDefault = resp.data.data.model.project.buildings
                    vm.formatBuildings()
                })
                .catch(function (err) {
                    vm.triggerLoader(false)
                    window.showError(err)
                });
        },
        async formatBuildings() {
            let vm = this
            await this.buildingsDefault.forEach(function (building) {
                let buildingFormat = {
                    title: building.name,
                    id: building.id,
                    levels: [],
                    isActive: false
                }
                building.levels.forEach(function (level) {
                    // console.log(vm.model)
                    let items = vm.model.items.filter(i => i.level_id === level.id && i.building.id === building.id)
                    let itemRows = []
                    if (items.length > 0) {
                        items.forEach(function (item) {
                            itemRows.push({
                                id: item.id,
                                apartmentNumber: item.apartment_number,
                                usefulSurface: item.useful_surface,
                                terraceSurface: item.terrace_surface,
                                gardenSurface: item.garden_surface,
                                price: item.price,
                                credit_price: item.credit_price,
                                status: item.status,
                                showStatusForClients: item.show_status_for_clients ? true : false,
                                showStatusForAgencies: item.show_status_for_agencies ? true : false,
                                highlighted: item.id === vm.toEditItemId ? true : false
                            })
                            if (item.id === vm.toEditItemId) {
                                buildingFormat.isActive = true
                            }
                        })
                    }
                    buildingFormat.levels.push({
                        title: level ? level.name : '',
                        ord: level ? level.sort_order : 0,
                        id: level ? level.id : '',
                        itemRows: itemRows
                    })
                });
                vm.buildings.push(buildingFormat)
            });
            setTimeout(function () {
                var $scrollElem = $(".highlighted").first();
                if($scrollElem.length) {
                    var $editModalContent = $('#edit_modal_content');
                    $editModalContent.animate({
                        scrollTop: $scrollElem.offset().top - $editModalContent.offset().top
                    }, 500);
                }
            }, 500);
        },
        setActive: function (building) {
            let self = this;
            building.isActive = true;
            this.activeTab = building;
            this.buildings.forEach(function (building) {
                if (building.id !== self.activeTab.id) {
                    building.isActive = false;
                }
            });
        },
        buildingOffers(building) {
            let selectedBuilding = this.buildings.filter(i => i.id === building.id)[0];
            let count = 0;
            if(selectedBuilding) {
                for (let i = 0; i < selectedBuilding.levels.length; i++) {
                    count += selectedBuilding.levels[i].itemRows.length;
                }
            }
            return count;
        },
        addItemRow: function (itemRows) {
            itemRows.push({
                apartmentNumber: '',
                usefulSurface: this.model.useful_surface,
                terraceSurface: this.model.terrace_surface,
                gardenSurface: this.model.garden_surface,
                price: this.model.price,
                credit_price: this.model.credit_price,
                status: 'available',
                showStatusForClients: true,
                showStatusForAgencies: false,
                highlighted: false
            });
        },
        removeItemRow: function (index, itemRows) {
            itemRows.splice(index, 1);
        },
        save() {
            let vm = this
            vm.triggerLoader(true)

            window.axios.post(`/developer/model-items-edit/${this.model.id}`, this.buildings)
                .then(function () {
                    vm.triggerLoader(false)
                    window.Swal.fire({
                        html: 'Modificarile au fost efectuate cu succes.',
                        icon: 'success',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(() => {
                        $('#editModelItemsModal').modal('hide');
                    }).then(() => {
                        let reloadWindowUrl = window.location.href;
                        reloadWindowUrl = reloadWindowUrl.split('#')[0];
                        window.location.href = reloadWindowUrl;
                    })
                })
                .catch(function (err) {
                    vm.triggerLoader(false)
                    window.showError(err)
                });
        }
    }
}
</script>
